import React, { Component } from "react";
import "../../../styles/pages/projects/ProjectConclusion.css";

export default class ProjectConclusion extends Component {
  render() {
    return (
      <div className="ProjectConclusion gutters">
        <div className="section-overview-container on-scroll-anim">
          <div className="section-title-container">
            <div className="g-tiny-text section-title">The Conclusion</div>
          </div>
          <div className="horizontal-line" />
        </div>
        <div className="g-sub-text description on-scroll-anim">
          {this.props.text}
        </div>
      </div>
    );
  }
}
